export default "__VITE_ASSET__a023b2c9__"